import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "app",
  style: {"background-color":"#2b3439"}
}
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  itemprop: "image",
  style: {"max-width":"150px","padding":"10px 0px"},
  src: "/static/img/logo-rope-risk-clean.png",
  alt: "Logo"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  id: "app"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.ptBR }, {
    default: _withCtx(() => [
      (_ctx.storeApp.state.apresentarLogoExterna)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.storeApp.state.apresentarLogoExterna)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_view)
          ]))
    ]),
    _: 1
  }, 8, ["locale"]))
}